import { render, staticRenderFns } from "./CriterionComparisonExport.vue?vue&type=template&id=148ddab1&scoped=true"
import script from "./CriterionComparisonExport.vue?vue&type=script&lang=js"
export * from "./CriterionComparisonExport.vue?vue&type=script&lang=js"
import style0 from "./CriterionComparisonExport.vue?vue&type=style&index=0&id=148ddab1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148ddab1",
  null
  
)

export default component.exports